const currentYear = new Date().getFullYear();

const page = {
  header: {
    mmmLogo: process.env.MEDIA_URL + "/media/images/logo-3-m.svg",
    walmartLogo: process.env.MEDIA_URL + "/media/images/logo-walmart.svg",
    walmartDesktopLogo:
      process.env.MEDIA_URL + "/media/images/walmart-logo@3x.png",
    walmartLink: "https://www.walmart.com/",
  },
  footer: {
    disclaimer:
      "*All product and company names are trademarks™ or registered® trademarks of their respective holders. Use of them does not imply any affiliation with or endorsement by them.",
    copy: ` © 3M ${currentYear}. All Rights Reserved.`,
    mmmLogo: process.env.MEDIA_URL + "/media/images/logo-3-m-red.svg",
  },
};

export default page;
